import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./header.scss";
import TextConstants from "../../../TextConstants";
import { PORTAL_BASE_URL } from "../../../env";
const AiCreatorCTA = ()=> {
  const utmSource = localStorage.getItem('utm_source')
  const location = useLocation();
  const isAiImagesPage = location.pathname === '/ai-images';
  const learnMoreLink = isAiImagesPage ? '/ai-creator' : '/ai-images';
  const linkText = isAiImagesPage ? 'Learn more' : 'Check out our AI Images';

    return (
      <div className="ai-creator-cta-container manrope f-16 pd-2-l justify-in-center" id="aiCreatorCta">
        <img src='/ai_creator/ai-star-white.svg' className="mr-1 ai-creator-banner-text" />
        <div className="ai-creator-banner-text">
        {isAiImagesPage? 'Discover our AI workflow for teams.' : 'Generate free AI images of your product in minutes.'}
        </div>
        <div className="ai-creator-banner-text-mobile">
        Product images in minutes.
        </div>
        <a className="ai-creator-link" href={learnMoreLink}>
            {linkText}
            <img src='/ai_creator/right-arrow.svg' />
        </a>
      </div>
    );
}

export default AiCreatorCTA;
